// The numbers behind the monthly chart: axes that line up and month names.

const MONTHS_SHORT = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/** @param {string} iso a date such as "2026-03-01" @returns {[number, number]} year and month (1-12) */
const yearAndMonth = (iso) => {
    const [year, month] = iso.split("-").map(Number);
    return [year, month];
};

/** "2026-03-01" -> "mar/26" */
export const monthLabel = (iso) => {
    const [year, month] = yearAndMonth(iso);
    return `${MONTHS_SHORT[month - 1]}/${String(year).slice(-2)}`;
};

/** "2026-03-01" -> "03/26" */
export const monthNumeric = (iso) => {
    const [year, month] = yearAndMonth(iso);
    return `${String(month).padStart(2, "0")}/${String(year).slice(-2)}`;
};

/**
 * The smallest "nice" step (1, 2, 2.5 or 5 times a power of ten) that makes
 * `intervals` steps reach `max`. Counts need whole steps, so they skip 2.5.
 *
 * @param {number} max
 * @param {number} intervals
 * @param {boolean} wholeNumbers
 */
export const niceStep = (max, intervals, wholeNumbers) => {
    if (!(max > 0)) return 1;
    const multipliers = wholeNumbers ? [1, 2, 5] : [1, 2, 2.5, 5];
    for (let power = 1; ; power *= 10) {
        for (const multiplier of multipliers) {
            if (multiplier * power * intervals >= max) return multiplier * power;
        }
    }
};

/**
 * A vertical axis for a series that starts at zero: the number of intervals
 * (4 to 6) that wastes the least room above the data, with a nice step.
 *
 * @param {number} max the largest value to show
 * @param {boolean} [wholeNumbers] the axis only has whole numbers (counts)
 * @returns {{intervals: number, step: number, max: number}}
 */
export const axis = (max, wholeNumbers = false) => {
    let best = null;
    for (const intervals of [4, 5, 6]) {
        const step = niceStep(max, intervals, wholeNumbers);
        const waste = (step * intervals - max) / (step * intervals);
        if (!best || waste < best.waste - 1e-9) best = {intervals, step, waste};
    }
    const {intervals, step} = /** @type {NonNullable<typeof best>} */ (best);
    return {intervals, step, max: step * intervals};
};
